function b64toBlob(base64, type = "application/octet-stream") {
  let base64Data = base64;
  // if the base64 includes data type part
  if (base64.includes(",")) {
    const parts = base64.split(",");
    if (parts.length === 2) {
      base64Data = parts[1];
    }
  }

  const binaryString = window.atob(base64Data);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type });
}

export const convertBase64ToFile = (
  base64: string,
  fileName: string,
  fileExtension: string,
  type: string
): File => {
  const blob = b64toBlob(base64);
  return new File([blob], `${fileName}.${fileExtension}`, { type });
};

export const logFormData = (formData) => {
  const plainObject = Object.fromEntries(formData.entries());

  // enable this to detect formData values- console.log(plainObject);
};
